import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, ColorSchemaMixin, NestingLevelMixin} from './../common/common.js';
import Environment from '../environment/environment.js';

import './table-th.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ContentMixin,
    ColorSchemaMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Table.Th',
    nestingLevelList: Environment.getNestingLevelList('boxCollection', 'inline'),
    classNames: {
      main: 'uu5-bricks-table-th uu5-common-text',
      //bg: 'uu5-common-bg'
    },
    defaults: {
      parentTagName: 'UU5.Bricks.Table.Tr'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainProps: function () {
    var props = this.buildMainAttrs();
    //this.props.background && (props.className += ' ' + this.getClassName().bg);
    return props;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <th {...this._getMainProps()}>
            {this.getChildren()}
            {this.getDisabledCover()}
          </th>
        ) : null
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/table-th.js